
<template>
    <div class="upload">
        <Upload
                :action="host"
                :headers="header"
                :data="data"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :on-error="handleError"
                :format="format"
                :max-size="maxSize"
                :show-upload-list="false"
                :typeUrl="drag?'drag':'select'"
                :multiple="multiple"
                :disabled="progress>0"
        >
            <slot name="style"></slot>
        </Upload>
        <dialog-con ref="dialog" @confirm="refreshHandle" @liveHandle="liveHandle" :isRefresh="isRefresh"></dialog-con>
    </div>
</template>
<style scoped>
.upload {
    cursor: pointer;
}
</style>
<script>
    import api from '../../api'
    import store from '../../store'
    import util from '../../libs/util'
    import dialogCon from './deleteConfirm.vue'
    export default{
        props: {
            format: {
                type: Array,
                default(){
                    return ['jpg', 'jpeg', 'png'];
                },
            },
            drag:{
                type:Boolean,
                default:true
            },
            type:{
                type:Number,
                required:true
            },
            maxSize: {
                type: Number
            },
            multiple:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                image: this.img || {},
                host:'',
                header:{
                   'Authorization':`${store.state.user.token.accessToken}`,
                },
                data:{
                    'x:type':this.type,
                    'x:originname': '',
                    key: '',
                    policy: '',
                    OSSAccessKeyId: '',
                    callback : '',
                    signature : '',
                    success_action_status: 200,
                },
                progress:0,
                filenameSuffix: '',
                originname: '',
                dir: '',
                isRefresh: 1,
                expire:''
            }
        },
        methods: {
            handleSuccess (res) {
                this.progress = 0;
                if(res.message === 'success'){
                    this.$emit('success',res);
                }else{
                    this.$Message.error('上传失败,请重新上传!');
                    this.$emit('errUpload');
                }
            },
            handleProgress(param){
                this.progress = param.percent;
                this.$emit('progress',parseInt(param.percent));
            },
            handleFormatError () {
                this.$emit('formatError');
            },
            handleMaxSize () {
                this.$emit('maxSizeError');
            },
            handleError(){
                this.progress = 0;
                this.$emit('uploadError');
            },
            handleBeforeUpload (file) {
                var timestamp = Date.parse(new Date());
                this.originname = file.name
                this.filenameSuffix = file.name.split('.')[1];
                this.data.key = this.dir + util.randomString() + '.' + this.filenameSuffix;
                Object.assign(this.data, {'x:originname': this.originname})
                this.$emit('beforeUpload',file);
            },
            refreshHandle(){
                this.$router.go(0)
            },
            liveHandle(){
                this.$router.go(-1)
            },
            getOssInfo() {
                api.files.uploadUrl(this.type)
                    .then(res => {
                        if(res){
                            this.expire = res.expire;
                            this.dir = res.dir;
                            this.data.policy= res.policy;
                            this.data.OSSAccessKeyId= res.OSSAccessKeyId;
                            this.data.callback = res.callback;
                            this.data.signature= res.signature;
                            this.host = res.action;
                        }
                    })
            }
        },
        created(){
            this.getOssInfo();
        },
        components: {
            dialogCon
        }
    };
</script>